import(/* webpackMode: "eager" */ "/home/node/deploy/src/app/shopping-cart/page.tsx");
